// import APIs
import { cudBatchDutyLines } from 'RestAPIs/employees/hours-table';

// import components
import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';

// import external libraries
import { useMutation, useQueryClient } from 'react-query';

// import types
import { CUDBatchDutyLinesParams } from './useCUDBatchDutyLines.types';

const useCUDBatchDutyLines = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (params: CUDBatchDutyLinesParams) => cudBatchDutyLines(params),

    {
      onSuccess: (_data, { employeeId }) => {
        queryClient.invalidateQueries(['hoursTable', employeeId]);
        showSuccessSnackbar();
      },
      onError: showErrorSnackbar
    }
  );
};

export default useCUDBatchDutyLines;
